module.exports = __webpack_public_path__ + "img/recipecalculator.005af413.png";